export const getOneTwelfthValue = insurance => {
  if(!insurance) {
    return 0;
  }
  return Math.round(parseFloat(insurance) / 12)
}
